import Bowser from 'bowser'
import get from 'lodash/get'

const ua =
  typeof window !== 'undefined' ? get(window, 'navigator.userAgent') : null

const bowserData = ua ? Bowser.parse(ua) : {}

export default bowserData
